import React from 'react';
import Header from './Header';
import Footer from './Footer';

function Layout({ children }) {
  return (
    <>
      <Header />
      <main id="content">{children}</main>
      <Footer />
    </>
  );
}

export default Layout;